import { ComponentInfoChatVO, ComponentInfoLoadChatsVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (
  input: ComponentInfoLoadChatsVO,
  page: number,
  offset: number
): Promise<ComponentInfoChatVO[]> => {
  return fetcher(`/api/componentInfo/chats?page=${page}&offset=${offset}`, 'POST', input)
}
